'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { MaxWidthWrapper } from '@/components/max-width-wrapper';
import { Separator } from '@/components/ui/separator';
import { FooterColumn } from './column';
import { baseNavigationLinks, connectLinks, moreLinks } from './constants';
import { FooterFooter } from './footer-footer';
import { NewsletterForm } from './newsletter-form';
export function FooterHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface FooterClientProps {
  wordmark: React.ReactNode;
}
const navigationLinks = [{
  label: 'Home',
  href: '/'
}, {
  label: 'Watch Now',
  href: '/browse'
}, ...baseNavigationLinks.slice(2)];
export function FooterClient(t0) {
  const $ = _c(8);
  const {
    wordmark
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator className="mb-4 bg-christ-white-900/50 md:mb-8" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FooterColumn title="Navigate" links={navigationLinks} LinkComponent={Link} />;
    t3 = <FooterColumn title="More" links={moreLinks} LinkComponent={Link} />;
    t4 = <FooterColumn title="Connect" links={connectLinks} LinkComponent={Link} className="col-span-2 md:col-span-1" />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="grid grid-cols-2 gap-8 font-medium text-sm uppercase tracking-[0.02em] md:gap-x-4 md:gap-y-8 lg:grid-cols-[1fr_1fr_1fr_2fr]">{t2}{t3}{t4}<div className="col-span-2 md:col-span-1"><NewsletterForm /></div></div>;
    t6 = <FooterFooter />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== wordmark) {
    t7 = <footer className="bg-black pt-8 pb-4 text-christ-white-900 md:pt-16"><MaxWidthWrapper size="xl"><div className="flex flex-col gap-4">{wordmark}{t1}{t5}{t6}</div></MaxWidthWrapper></footer>;
    $[6] = wordmark;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}